module.exports = __webpack_public_path__ + "img/71-l.f864b7fc.png";